<template>
  <div class="modal" tabindex="-1" id="wheel__modal">
    <transition name="fadeOut" v-if="stepNumber == 1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body position-relative pt-0">
            <div data-bs-theme="dark">
              <button type="button" class="btn-close position-absolute end-0 m-0 pt-4 btn-close-white"
                data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-12 text-center mt-4 mb-2">
                  <img src="../assets/images/campaigns/2026/black-friday/lbl-01.png" alt="Black Friday" class="wheel-title-img">
                </div>
                <div class="col-12 text-center mb-3">
                  <span class="wheel-heading lh-1">YOUR BLACK FRIDAY <br>
                    BONUS IS HERE</span>
                </div>
                <div id="wheel__interface" class="col-12 mb-3">
                  <div class="roulette-container position-relative">
                    <img src="@/assets/images/campaigns/2026/black-friday/wheel.png" alt="ruleta" class="wheel"
                      :style="{ transform: `rotate(${rotation}deg)` }" />
                    <div class="position-absolute start-50 translate-middle spinner top-0">
                      <img src="../assets/images/campaigns/2026/black-friday/pointer.png" alt="" class=" w-50">
                    </div>
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center mb-4">
                  <div class=" btn-spin rounded-pill text-center" @click="spin">SPIN & WIN</div>
                </div>
                <div class="col-12 text-center mb-3">
                  <span class="wheel-tagline">THIS IS NOT YOUR AVERAGE <br> BLACK FRIDAY <span class="text-nowrap">POP-UP.</span></span>
                </div>
                <div class="col-12 col-lg-10 text-center">
                  <p class="terms">
                    Does not apply with other promotions.<br />
                    Valid with the purchase of a Vacation Package to&nbsp;Mexico.<br>
                    *Only with the purchase of a $699 package.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fadeOut" mode="out-in">
      <div class="modal-dialog" v-if="stepNumber == 2" key="step2">
        <div class="modal-content modal-prize">
          <div class="modal-body position-relative p-0">
            <div data-bs-theme="dark">
              <button type="button" class="btn-close position-absolute end-0 m-0 pt-4 btn-close-white "
                data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="container prize-container">
              <div class="row justify-content-center">
                <div class="col-12 text-center mt-5">
                  <span class="prize-title">YOU WON</span>
                </div>
                <div class="col-12 text-center">
                  <img v-if="selectedPrize.imgUrl" :src="selectedPrize.imgUrl" :alt="selectedPrize.name" class="prize-img">
                </div>
                <div class="col-12 text-center my-3">
                  <span class="prize-subtitle">ENTER YOUR EMAIL <br> TO REDEEM IT</span>
                </div>
                <div class="col-12 col-md-10 prize-form">
                  <lotteryForm :prizeCode="selectedPrize.code" :prizeName="selectedPrize.name" btnLabel="REGISTER NOW"
                    :showDisclaimer="false" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { useWebsiteStore } from '@/store/website';
import lotteryForm from "@/components/TheLotteryForm.vue"
import Confetti from 'canvas-confetti'

export default {
  data() {
    return {
      // En el orden de la rueda: empieza arriba (12 en punto) y sigue en sentido horario, 72° por premio
      prizes: [
        {
          name: "FREE VEGAS TRIP",
          code: '#FREEVEGAS',
          imgUrl: require("../assets/images/campaigns/2026/black-friday/prizes/prize-05.png")
        },
        {
          name: "$100 USD DISCOUNT",
          code: '#100USDISCOUNT',
          imgUrl: require("../assets/images/campaigns/2026/black-friday/prizes/prize-01.png")
        },
        {
          name: "FREE CRUISE",
          code: '#FREECRUISE',
          imgUrl: require("../assets/images/campaigns/2026/black-friday/prizes/prize-04.png")
        },
        {
          name: "$75 USD DISCOUNT",
          code: '#75USDISCOUNT',
          imgUrl: require("../assets/images/campaigns/2026/black-friday/prizes/prize-02.png")
        },
        {
          name: "$50 USD DISCOUNT",
          code: '#50USDISCOUNT',
          imgUrl: require("../assets/images/campaigns/2026/black-friday/prizes/prize-03.png")
        }
      ],
      rotation: 0,
      initialOffset: 0,
      isSpinning: false,
      isFlipping: false,
      selectedPrize: {},
      stepNumber: 1,
    };
  },
  components:
  {
    lotteryForm
  },
  mounted() {
     // Misma vigencia y vista previa (?campaign=) que la campaña del sitio (store/website.js)
     if (this.websiteStore.getIsCampaign && this.websiteStore.campaign.showWheel) {
        this.showModal()
        const anglePerPrize = 360 / this.prizes.length;
        this.initialOffset = 1;
        this.rotation = 0;
     }
  },
  computed: {
    websiteStore() {
      return useWebsiteStore();
    }
  },
  methods: {
    showModal() {
      let bannerModal = document.querySelector('#wheel__modal', { backdrop: false });
      console.log(bannerModal)
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.show();
    },
    spin() {
      if (this.isSpinning) return;

      this.isSpinning = true;
      this.selectedPrize = null;

      const total = this.prizes.length;
      const anglePerPrize = 360 / total;
      const extraSpins = 5;
      const randomAngle = Math.floor(Math.random() * 360);

      const finalRotation = 360 * extraSpins + randomAngle;

      this.rotation += finalRotation;

      setTimeout(() => {
        this.isSpinning = false;
        const normalizedAngle = this.rotation % 360;
        const anglePerPrize = 360 / this.prizes.length;
        const adjustedAngle = (360 - normalizedAngle) % 360;
        const prizeIndex = Math.floor(adjustedAngle / anglePerPrize);
        this.selectedPrize = this.prizes[prizeIndex];
        setTimeout(() => {
          this.stepNumber = 2
          this.getConfetti()
        }, 4000);
      }, 500);
    },
    getConfetti() {
      Confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 2000,
        shapes: ['circle'],
        colors: ['#EF2427', '#000000', '#ffffff']
      })
    },
  }
};
</script>

<style scoped>
.modal-content {
  background: linear-gradient(180deg, #4C4C4C 0%, #272727 50%, #010101 100%);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 100%;
  width: 100%;

}

.btn-close {
  background-color: transparent !important;
}

.lbl {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
  color: #fff;
  letter-spacing: 1px;
}

#wheel__interface {
  text-align: center;
  font-family: Arial, sans-serif;
}

.roulette-container {
  position: relative;
  width: 300px;
  height: 300px;
  margin: 0 auto;
}

.wheel {
  width: 100%;
  height: 100%;
  transition: transform 4s cubic-bezier(0.33, 1, 0.68, 1);
  transform-origin: center;
  border-radius: 50%;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.spinner {
  margin-top: 2rem;
}

.btn-spin {
  cursor: pointer;
  color: #fff;
  background: #F22122;
  border-color: none !important;
  box-shadow: 0px 6px 0px 0px #B21100;
  padding: 0.25rem 2rem;
  font-family: "Montserrat", sans-serif;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 1px;
}

.wheel-title-img {
  width: 65%;
  max-width: 320px;
}

.wheel-heading {
  display: inline-block;
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 26px;
  color: #fff;
}

.wheel-tagline {
  display: inline-block;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.1;
  color: #fff;
}

.terms {
  font-size: 11px;
  color: white !important;
  font-weight: 400;
}

.baloo-2-bold {
  font-family: "Baloo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
}

@media(max-width:420px) {
  .prize-title {
    font-size: 44px;
  }

  .prize-subtitle {
    font-size: 21px;
  }

  .prize-form :deep(.btn-spin-02) {
    font-size: 22px;
    padding: 0.25rem 1.5rem;
  }

  .prize-container {
    padding-bottom: 90px;
  }

  .wheel-heading {
    font-size: 22px;
  }

  .wheel-tagline {
    font-size: 18px;
  }

  .btn-spin {
    font-size: 26px;
  }

  .terms {
    font-size: 10px;
    word-break: keep-all;
  }
}

.w-50 {
  width: 3%;
}

/*--------PRIZE MODAL--------*/

.modal-content.modal-prize {
  background: url('../assets/images/campaigns/2026/black-friday/prize-bg.png') center bottom / cover no-repeat, #8F1410;
  min-height: 100%;
  width: 100%;
  color: #fff;
}

.prize-container {
  /* deja libre la franja de "BLACK FRIDAY" que trae el fondo abajo */
  padding-bottom: 110px;
}

.prize-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 56px;
  line-height: 1;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

.prize-img {
  width: 60%;
  max-width: 280px;
  margin-top: 0.75rem;
}

.prize-subtitle {
  display: inline-block;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 26px;
  line-height: 1.05;
  letter-spacing: 1px;
}

.prize-form :deep(.form-control) {
  border: 0;
  border-radius: 10px;
  padding: 0.6rem 0.75rem;
  font-size: 15px;
  font-family: "Montserrat", sans-serif;
}

.prize-form :deep(.form-control:disabled) {
  background-color: #fff;
}

.prize-form :deep(.form-control::placeholder) {
  color: #8C8C8C;
}

.prize-form :deep(.btn-spin-02) {
  background: #4D4D4D;
  box-shadow: 0px 6px 0px 0px #000000;
  font-family: "Montserrat", sans-serif;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 1px;
  padding: 0.25rem 2rem;
  white-space: nowrap;
}

.luckiest-guy-regular {
  font-family: "Luckiest Guy", cursive;
  font-weight: 400;
  font-style: normal;
}

@media(max-width:375px) {
  .terms {
    font-size: 9px;
  }
}

@media(max-width:400px) {
  .terms {
    font-size: 11px;
    letter-spacing: -0.5px;
  }
}
</style>